import ModalDeleteBadge from './ModalDeleteBadge'

export default ModalDeleteBadge
